import { TypeKeys, WidgetBlockAction } from './types';

type ErrorLoadingTemplateAction = WidgetBlockAction<TypeKeys.ERROR_LOADING_TEMPLATE, { error: Error }>;

const errorFetchingWidgetTemplate = (widgetId: string, instanceId: string, error: Error): ErrorLoadingTemplateAction => ({
    type: TypeKeys.ERROR_LOADING_TEMPLATE,
    payload: {
        widgetId,
        instanceId,
        error,
    },
});

export default errorFetchingWidgetTemplate;
export { ErrorLoadingTemplateAction };
